import React from "react";

export default function VsCode() {
  return (
    <iframe
      src="https://github1s.com/Devansh-Singh-Parmar/threejs_tshirt_web"
      frameBorder="0"
      title="VsCode"
      className="h-full w-full bg-ub-cool-grey"
    ></iframe>
  );
}

export const displayVsCode = () => {
  <VsCode> </VsCode>;
};
